import React, { useEffect, useState, useMemo } from "react";
import "../../Styles/styles-StatusTracker.css";
import { useSelector, useDispatch } from "react-redux";
import { 
    Avatar,
    Tooltip,
} from "antd";
import { getTextColorBasedOnBg } from '../../Utils/color_utils';
import { createStatusAvatarList } from './statusTrackerUtil';

export const PlayerHeader = ({ filteredTrackerData, uniqueKeys }) => {
    const {
        info: { team_logo },
    } = useSelector(({ team }) => team);
    const [statusCountList, setStatusCountList] = useState([]);
    const [visibleStatusAvatars, setVisibleStatusAvatars] = useState([]);
    const [hiddenStatusAvatars, setHiddenStatusAvatars] = useState([]);
    const MAX_AVATAR_COUNT = 3;
    const {
        trackerData,
        statuses
    } = useSelector(({ statusTracker }) => statusTracker);

    useEffect(() => {
        setStatusCountList([]);
        setVisibleStatusAvatars([]);
        setHiddenStatusAvatars([]);
    }, [uniqueKeys])

    const trackerDS = useMemo(() => {
        const uKeysSet = new Set([...uniqueKeys]);
        return Object.fromEntries(Object.entries(trackerData).filter(([key]) => uKeysSet.has(key)))
    }, [uniqueKeys, filteredTrackerData, trackerData])

    useEffect(() => {
        createStatusAvatarList(trackerDS, statuses, setStatusCountList);     
    }, [trackerDS])

    useEffect(() => {
        if (statusCountList && statusCountList.length > 0) {
            setVisibleStatusAvatars(statusCountList.slice(0, MAX_AVATAR_COUNT));
            setHiddenStatusAvatars(statusCountList.slice(MAX_AVATAR_COUNT));
        } else {
            setVisibleStatusAvatars(null);
            setHiddenStatusAvatars(null);
        }
    }, [statusCountList])

    const getHiddenStatusAvatarTooltip = () => {
        return hiddenStatusAvatars.map(([hiddenStatus, count]) => {
            const statusColor = hiddenStatus.color;
            return (
                <div>
                    <span
                        style={{
                            width: 10,
                            height: 10,
                            backgroundColor: statusColor
                        }}
                    >
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <span>
                        {` ${hiddenStatus.name}: ${count}`}
                    </span>
                </div>
            )
        })
    }


    return (
        <>
            <div 
                className="tracker-header-card" 
                style={
                    (statusCountList && statusCountList.length > 0) 
                    ?
                    {justifyContent: 'space-between'}
                    :
                    {justifyContent: 'flex-start'}
                }
            >
                <div
                    className="tracker-header-card-header-txt"
                >
                    Players
                </div>
                {
                    statusCountList && statusCountList.length > 0 && (
                        <div className="tracker-header-card-status-count">
                            <Avatar.Group 
                                // maxCount={2}
                                size={22}
                                style={{ display: 'flex', flexDirection: 'column'}}
                            >
                                {
                                    visibleStatusAvatars && visibleStatusAvatars.length > 0 && 
                                    visibleStatusAvatars.map(([status, count], idx) => {
                                        const statusColor = status?.color || 'black';
                                        const statusName = status?.name || '';
                                        return (
                                               <Tooltip
                                                key={`visible-header-avatar-${idx}`}
                                                title={`${statusName}: ${count}`}
                                               >
                                                     <Avatar 
                                                        style={{ 
                                                            backgroundColor: statusColor,
                                                            color: getTextColorBasedOnBg(statusColor)
                                                        }}
                                                        key={`header_avatar_${idx}`}
                                                    >
                                                        {count}
                                                    </Avatar>
                                               </Tooltip>
                                        )
                                    })
                                }

                                {
                                    hiddenStatusAvatars && hiddenStatusAvatars.length > 0 && (
                                        <Tooltip title={getHiddenStatusAvatarTooltip}>
                                            <Avatar>+{hiddenStatusAvatars.length}</Avatar>
                                        </Tooltip>
                                    )
                                }
                            </Avatar.Group>
                        </div>
                    )
                }
                
            </div>
        </>
    
    );
};
